import { observer } from "mobx-react-lite";
import { useAppStore } from "@/store";
import { EntityNotFoundType, NotFoundPage } from "@/pages/not-found/NotFoundPage";
import { MdsItemListSkeletonRow } from "@/design-system/components/item-list/rows/MdsItemListSkeletonRow";
import { MdsItemListRowType, MdsItemListSize } from "@/design-system/components/item-list/types";
import { MdsItemListSkeletonRowData } from "@/design-system/components/item-list/types/MdsItemListRowTypes";
import { useTabPageStore } from "@/hooks/useTabPageStore";

export const SessionsViewPage = observer(function SessionsViewPage() {
  const { store: appStore } = useAppStore();
  const page = useTabPageStore("sessionsViewPage");
  page.useEffects();

  if (page.showNotFound) {
    /**
     * @TODO - Swap this.
     */
    return <NotFoundPage entityType={EntityNotFoundType.Template} />;
  }

  const session = page.itemObservable;

  const skeletonRowData: MdsItemListSkeletonRowData = {
    key: "skeleton",
    type: MdsItemListRowType.Skeleton,
    size: MdsItemListSize.Large,
    payload: {},
  };

  if (!session) return <MdsItemListSkeletonRow data={skeletonRowData} />;

  const sessionEvents = appStore.sessionEvents.all.filter(event => event.sessionId === session.id);

  const sessionEventData = sessionEvents.map(event => event.modelData);

  return (
    <>
      <div>
        <section>
          <h2>Session</h2>
          <div>
            <span>ID: {session.id}</span>
          </div>
        </section>

        <section>
          <pre>{JSON.stringify(session.modelData, null, 2)}</pre>
        </section>

        <section>
          <h3>Session Events</h3>
          <div>
            {sessionEventData.length > 0 ? (
              sessionEventData.map((event, index) => (
                <div key={index}>{JSON.stringify(event, null, 2)}</div>
              ))
            ) : (
              <p>No events found for this session</p>
            )}
          </div>
        </section>
      </div>
    </>
  );
});
